import { ErpWorkflowOperationStep } from '../model/erpworkflowoperationstep';
import { ErpWorkflowOperation } from '../model/erpworkflowoperation';
import { ErpWorkflowHistoryItem } from '../model/erpworkflowhistoryitem';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HisBackendService } from 'hisng';

@Injectable()
export class ErpWorkflowService {
    constructor(
        private readonly backendService: HisBackendService
    ) { }

    findNextPossibleWorkflowOperations(processType: string, useCaseIdent: string, processId: number): Observable<ErpWorkflowOperation> {
        return this.backendService.getData( `api/v1/rm/erp/workflow/${processType}/${useCaseIdent}?processId=${processId}` );
    }

    createNextWorkflowOperationStep(operationStep: ErpWorkflowOperationStep): Observable<number> {
        return this.backendService.postData( 'api/v1/rm/erp/workflow/', operationStep );
    }

    loadHistory(processType: string, processId: number): Observable<ErpWorkflowHistoryItem[]> {
        return this.backendService.getData( `api/v1/rm/erp/workflow/history/${processType}?processId=${processId}` );
    }
}
